import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQuoraComponent } from './simple-icons-quora.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQuoraComponent ],
    exports:      [ SimpleIconsQuoraComponent ],
    bootstrap:    []
})
export class SimpleIconsQuoraModule {}
